var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.detail && _vm.detail.times[0] < _vm.curTime && _vm.curTime < _vm.detail.times[1])?_c('div',{staticClass:"adv-banner"},[(_vm.detail.link)?[_c('a',{attrs:{"href":_vm.detail.link,"target":"_blank"}},[_c('el-image',{attrs:{"src":_vm.aliUrl + _vm.detail.url}})],1)]:[_c('el-image',{attrs:{"src":_vm.aliUrl + _vm.detail.url}})]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }